import { type Country, useCountries, useIntl, useSettings } from '@capsicum/common';
import { CountrySelectModal } from '@capsicum/common-web';
import { useMemo } from 'react';

type DeliveryCountrySelectProps = {
	iso2Country?: string;
	onChange: (value: string) => void;
	onClose: () => void;
};

export const DeliveryCountrySelect = ({ iso2Country, onChange, onClose, ...props }: DeliveryCountrySelectProps) => {
	const { $t } = useIntl();
	const { settings } = useSettings();

	const { getCountryBy } = useCountries();

	const country = useMemo(
		() => getCountryBy(iso2Country?.toUpperCase(), 'iso2') as Country,
		[iso2Country, getCountryBy]
	);

	const onItemChange = (country: Country) => onChange(country.iso2);

	return (
		<CountrySelectModal
			hiddenCountries={settings.mwsBannedCountries}
			searchPlaceholder={$t('rewards.auctions.searchCountryPlaceholder')}
			testID="delivery-country-select"
			title={$t('requirements.common.form.country.listTitle')}
			value={country}
			onChange={onItemChange}
			onClose={onClose}
			{...props}
		/>
	);
};
